import React from 'react';
import {
  dispatch,
  getCartByCustomer,
  OfflineCurrentCustomerMetadata,
  OfflineTaskType,
  store,
  updateExtraDetails,
  updateOfflinePaymentDetails,
} from '@zonofi/zono-money-store';
import { SVGS } from '../assets';
import { ReactComponent as ArrowRight } from '@zonofi/svg-icons/arrow_right.svg';
import { useNavigate } from 'react-router-dom';
import { FIELD_OPS_ROUTES, PaymentModeType } from '../constants';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';
import { TouchableOpacity } from '../common';

interface SyncTransactionCardProps {
  type: OfflineTaskType;
  customer: OfflineCurrentCustomerMetadata;
  payload: any;
}

export const SyncTransactionCard: React.FC<SyncTransactionCardProps> = ({
  type,
  customer,
  payload,
}) => {
  const { customerId } = customer;
  const customerCart = getCartByCustomer(store.getState(), customerId);
  const navigate = useNavigate();

  const getCardImage = () => {
    switch (type) {
      case OfflineTaskType.PLACE_ORDER:
        return <img src={SVGS.CartTransaction} />;
      case OfflineTaskType.COLLECT_PAYMENT:
        return <img src={SVGS.PaymentTransaction} />;
      default:
        return null;
    }
  };

  const getHeading = () => {
    switch (type) {
      case OfflineTaskType.PLACE_ORDER:
        return 'Order #-';
      case OfflineTaskType.COLLECT_PAYMENT:
        return (
          payload?.data?.paymentRefCode ??
          payload?.data?.instrumentNumber ??
          '#-'
        );
      default:
        return null;
    }
  };

  const getDescription = () => {
    switch (type) {
      case OfflineTaskType.PLACE_ORDER:
        const desc1 = `${customerCart?.lines.length ?? '#'} SKUs`;
        const desc2 = `Order Amount: ${getFormattedAmount(
          customerCart?.lines?.reduce((acc, i) => {
            return acc + Number(i?.unitPrice) * (i?.quantity || 1);
          }, 0) || 0
        )}`;
        return `${desc1}  •  ${desc2}`;
      case OfflineTaskType.COLLECT_PAYMENT:
        return `Payment Mode: ${PaymentModeType[payload?.data?.paymentMode as keyof typeof PaymentModeType]}  •  Amt. Paid: ₹${payload?.data?.amountPaid}`;
      default:
        return null;
    }
  };

  const onNavigate = () => {
    switch (type) {
      case OfflineTaskType.PLACE_ORDER:
        dispatch(updateExtraDetails({ ...customer }));
        navigate(
          `${FIELD_OPS_ROUTES.OFFLINE_CART.replace(':customerId', customerId)}`
        );
        break;
      case OfflineTaskType.COLLECT_PAYMENT:
        dispatch(updateOfflinePaymentDetails(payload));
        navigate(
          `${FIELD_OPS_ROUTES.OFFLINE_PAYMENT_DETAILS.replace(':customerId', payload?.data?.inviteId)}`
        );
        break;
      default:
        break;
    }
  };

  return (
    <TouchableOpacity className="txn-item" onPress={onNavigate}>
      <div className="txn-item-content">
        {getCardImage()}
        <div className="font-semibold">
          <div className="txn-item-content-heading">{getHeading()}</div>
          <span className="txn-item-content-desc">{getDescription()}</span>
        </div>
      </div>
      <ArrowRight color="#8C8C8C" />
    </TouchableOpacity>
  );
};
